import React from 'react';
import { resolveListingCondition } from '../../util/listingCondition';
import css from './SectionConditionTags.module.css';

const SectionConditionTags = props => {
  const { publicData } = props;

  const conditionLabel = resolveListingCondition(publicData);

  if (!conditionLabel) {
    return null;
  }

  return (
    <div className={css.root}>
      <span className={css.conditionLabel}>Condition</span>
      <span className={css.conditionBadge}>{conditionLabel}</span>
    </div>
  );
};

export default SectionConditionTags;
